import MutationApi from '../remote/mutationApi'

export const transferTabMutation = async (approverId, toEmployeeId, fromEmployeeId, orderUuid) => {
  const result = await MutationApi.transferOrder({
    orderUuid,
    employeeId: toEmployeeId,
    reason: `Transferred from Employee ${fromEmployeeId}`,
    approverId,
  })

  if (result?.status !== 201) {
    throw new Error('Failed to transfer tab')
  }

  const curMutation = result?.data?.orderMutations?.[0]
  if (!curMutation?.applied) {
    throw new Error(curMutation?.friendlyMessage || 'Failed transfer tab')
  }

  return curMutation
}
